// @script
import columnDefinitions from './common-column-definitions.json';
import { getParentRow, registerGlobalHandler } from './helpers';
/**
 * Get column's definition from column key value.
 * @param {string} key
 */
const getColumnDefinitionByKey = (key) => columnDefinitions[key];

/**
 * Gets data-id value from attributes.
 * @param {DOM element} element
 */
const getDataId = (element) => getParentRow(element).getAttribute('data-id');

export const getSelectRowColumn = ({
    enableFixColumn,
    enableSelectRow,
    onSelectRow,
    widthType
}) => {
    if (!enableSelectRow) {
        return [];
    }
    const icon = "group";
    const getWarningTemplate = () => {
        return "{{if ${warningMessages} == '' }}" +
            "<center><button class='MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary'" +
            "onclick='window.handleOnSelectRow(this)' style='font-size:10px'>Add</button></center>" +
            "{{else}}" +
            "<center><span class='fa fa-exclamation-triangle status-icon' style='color:#EDDB1E'>" +
            "</span></center>" +
            "{{/if}}";
    };
    const handleOnSelectRow = (element) => onSelectRow(getDataId(element), element.offsetTop);
    registerGlobalHandler('handleOnSelectRow', handleOnSelectRow);

    const selectColumnRow = {
        allowFiltering: false,
        allowHiding: false,
        headerText: 'Add To Schedule',
        isFixed: enableFixColumn,
        key: 'warningMessages',
        readOnly: true,
        template: getWarningTemplate(),
        allowTooltips: true,
        width: widthType === 'px' ? 110 : '5%'
    };
    return [selectColumnRow];
};

/**
 * Enable the custom column RowPanel if has rowPanelRender
 * if not return the normal template
 * @param {{
 *  column: {object},
 *  onToggleRowExpand: {function}
 * }}
 */
export const getTemplate = ({ column, onToggleRowExpand }) => {
    const { rowPanelRender, template, key } = column;
    if (!rowPanelRender) {
        return template;
    }

    const handleOnRowPanelRender = (element) => onToggleRowExpand(getParentRow(element));
    registerGlobalHandler('handleOnRowPanelRender', handleOnRowPanelRender);
    return (
        `<center>
            <button data-key="${key}" onclick="window.handleOnRowPanelRender(this)">
                <i class="fa fa-line-chart"></i>
            </button>
        </center>`
    );
};

export const getColumns = (columns) => columns
    .map((column) => typeof column === 'object' ? column : getColumnDefinitionByKey(column));

